import NotificationTab from "./notification-tab";

export default NotificationTab